import type { LucideIcon } from 'lucide-react';
import type { ComponentType, ReactNode, SVGProps } from 'react';

export type DashboardNavIcon = LucideIcon | ComponentType<SVGProps<SVGSVGElement>>;

export type DashboardNavItem = {
  id: string;
  label: string;
  icon: DashboardNavIcon;
  dot?: boolean;
  dropdown?: boolean;
  disabledReason?: string | undefined;
  separateFirstLevel?: boolean;
  children?: { id: string; label: string; disabledReason?: string | undefined }[];
};

export type DashboardConnectionTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export type DashboardChatMessage = {
  id: string;
  role: 'assistant' | 'user';
  content: ReactNode;
  createdAt?: string | number | Date | undefined;
  contentFormat?: 'plain' | 'markdown' | undefined;
};

export type DashboardConversation = {
  id: string;
  title: string;
};

export enum DashboardFlowCardStatus {
  Done = 'done',
  Active = 'active',
  Running = 'running',
  Waiting = 'waiting',
}

export type DashboardGraphInsertPosition = 'start' | 'end';

export type DashboardFlowCard = {
  id: string;
  category: string;
  title: string;
  status: DashboardFlowCardStatus;
  count: number;
  description?: string | undefined;
  progress?: number | undefined;
  subtasks?: DashboardFlowSubtask[] | undefined;
  outcome?:
    | {
        title: string;
        summary: string;
        metrics?: { label: string; value: string }[] | undefined;
      }
    | undefined;
  review?: DashboardFlowReview | undefined;
  actions?: DashboardFlowAction[] | undefined;
};

export type DashboardFlowReview = {
  id: string;
  title: string;
  value: string;
  language?: string | undefined;
  editable?: boolean | undefined;
  helperText?: string | undefined;
};

export type DashboardFlowSubtask = {
  id: string;
  title: string;
  status: DashboardFlowCardStatus;
};

export type DashboardFlowAction = {
  id: string;
  label: string;
  disabled?: boolean | undefined;
  pending?: boolean | undefined;
  tone?: 'primary' | 'secondary' | 'danger' | undefined;
};

export type DashboardAgent = {
  id: string;
  name: string;
  description?: string;
  icon: LucideIcon;
  featured?: boolean;
  presets?: string[];
};

export type DashboardWorkspaceStats = {
  skills: number;
  tools: number;
  presets: number;
  sessions: number;
};
